// extracted by mini-css-extract-plugin
export default {"aboutTitle":"WhatWeAre_aboutTitle__d0pnc","aboutTitleWrapper":"WhatWeAre_aboutTitleWrapper__1AlgN","emTitle":"WhatWeAre_emTitle__NUadB","btn":"WhatWeAre_btn__s3XeA"};